/* eslint-disable no-underscore-dangle, no-undef */

import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { hydrate } from 'react-dom';
import createStore from 'services/redux/store';
import App from './App';
import routes from './routes';

const store = createStore(window.__PRELOADED_STATE__);

hydrate(
  <BrowserRouter>
    <App
      store={store}
      routes={routes}
      initialData={window.__PRELOADED_DATA__}
      extraData={window.__PRELOADED_EXTRA_DATA__}
    />
  </BrowserRouter>,
  document.getElementById('root'),
);

/**
 * Announce that hydration is done, the same way `web/src/index.js` does.
 *
 * Until this ran, the document was server-rendered HTML: painted, scrollable, focusable and
 * completely inert. A click in that window focuses its target and is silently discarded —
 * react-dom@17 does not replay it. This app is SSR-then-hydrate exactly like `web`, so it has
 * exactly the same window, and nothing was signalling the end of it.
 *
 * `web`'s live suite waits on this flag before touching a page (`tests/live/fixtures.mjs` wraps
 * `page.goto`/`page.reload`), and its guard is `!document.getElementById('root') || hydrated` —
 * this app renders a `#root`, so without the flag that wait can only time out.
 */
document.documentElement.dataset.hydrated = 'true';

if (module.hot) {
  module.hot.accept();
}
